import React from "react";
import { Reveal } from "./Reveal";
import { CountUp } from "./CountUp";
import { STATS } from "../../data/content";

export const Resume = () => {
  return (
    <section id="resume" data-testid="resume-section" className="bg-matte py-24 md:py-32 px-6 md:px-12 lg:px-16">
      <Reveal>
        <p className="eyebrow mb-4">By The Numbers</p>
        <h2 className="heading text-5xl sm:text-6xl lg:text-7xl text-cream mb-16">The Resume.</h2>
      </Reveal>

      <div className="grid grid-cols-2 md:grid-cols-6 gap-px bg-silver/10 border border-silver/10">
        {STATS.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.07}
            className="bg-matte"
          >
            <div
              data-testid={`stat-card-${i}`}
              className="group bg-charcoal/30 p-7 md:p-8 h-full flex flex-col justify-between transition-all duration-300 hover:bg-charcoal/60 hover:-translate-y-1"
            >
              <div className="heading text-6xl md:text-7xl text-stone group-hover:text-cream transition-colors">
                <CountUp value={s.value} prefix={s.prefix || ""} suffix={s.suffix || ""} />
              </div>
              <p className="mt-6 uppercase tracking-[0.15em] text-[0.7rem] text-cream/60 leading-snug">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
